import type { Modification } from '@carboncopyco/types';
import constate from 'constate';
import type { Transaction } from './types';
import {
  type WizardState,
  useCreateTransactionRuleReducer,
} from './useCreateTransactionRuleReducer';

export interface UseCreateTransactionRule {
  transactionModifications: Modification<'transaction_rule'>[];
  onLearnMoreClick?: (url: string) => void;
  transactions: Transaction[];
  cancelCreation: () => void;
  submitCreation: (
    transactionRule: WizardState['transactionRule'],
    refresh?: boolean
  ) => Promise<unknown>;
  isVisualSearch?: boolean;
  cancelVisualSearch?: () => void;
}

const useCreateTransactionRule = ({
  onLearnMoreClick,
  transactions,
  transactionModifications,
  cancelCreation,
  submitCreation,
  isVisualSearch,
  cancelVisualSearch,
}: UseCreateTransactionRule) => {
  const reducer = useCreateTransactionRuleReducer();

  return {
    onLearnMoreClick,
    transactions,
    transactionModifications,
    cancelCreation,
    submitCreation,
    isVisualSearch,
    cancelVisualSearch,
    ...reducer,
  };
};

export const [CreateTransactionRuleProvider, useCreateTransactionRuleContext] =
  constate(useCreateTransactionRule);
